var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"error"},[(_vm.error.statusCode === 503)?_c('maintenance'):_c('error',{attrs:{"error":_vm.error}})],1),_vm._v(" "),_c('wptv-footer',{attrs:{"used-o-s":_vm.os}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }